import React, { useContext } from 'react';
import { BackArrowIcon } from 'assests/GmsIcons';
import { useHistory } from 'react-router-dom';
import { SAVE_TEST } from '../../utils/Constants';
import { ABContext } from '../../contexts/ABContext';

type TABDetailHeaderProps = {
    testName?: string;
    onSave: () => Promise<boolean | undefined>;
}

const ABDetailHeader = ({ testName, onSave }: TABDetailHeaderProps) => {
    const history = useHistory();
    const { clearData } = useContext(ABContext);

    const onBackPress = () => {
        history?.replace("/gms/ab");
        clearData();
    }

    return (
        <div id="save-button" className={`tw-flex tw-items-center tw-justify-between tw-border-b tw-py-1.5  tw-bg-[#FAFAFC]`}>
            <div className='tw-flex tw-items-center tw-gap-3'>
                <button onClick={onBackPress}><BackArrowIcon /></button>
                <label className={`tw-text-[#091E42] tw-text-[24px] tw-font-semibold`}>{testName ?? ''}</label>
            </div>
            <button className={`button-style tw-w-max`} onClick={onSave}>{SAVE_TEST}</button>
        </div>
    );
}

export default ABDetailHeader;